// Module
var code = "<react-component name=\"GeneralKioskAttendancesReport\"></react-component>\n";
// Exports
module.exports = code;